import styled from 'styled-components';

export const FooterBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({theme}) => theme.getSize(2)};
  padding: ${({theme}) => `${theme.getSize(1)} ${theme.getSize(2)}`};
  border-top: 1px solid ${({theme}) => theme.colors.palettes.neutral[30][100]};
  background-color: ${({theme}) => theme.colors.palettes.neutral[10][100]};
`;

export type FooterCounterProps = {
  $isOverLimit: boolean;
  $isNearLimit?: boolean;
};

export const FooterCounter = styled.span<FooterCounterProps>`
  color: ${({theme, $isOverLimit, $isNearLimit}) =>
    $isOverLimit
      ? theme.colors.severity.danger
      : $isNearLimit
        ? theme.colors.severity.warning
        : theme.colors.text.secondary};
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};
`;
